import React, { useEffect, useState } from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import { PieChart, Pie, Cell } from 'recharts';
import { useNavigate } from 'react-router-dom';

const ClientOnboardingStatus = ({ data: onboarding, totalClients, selectedUserId }) => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!onboarding) return;

      const COLORS = [
      'rgba(245, 75, 177, 1)',
      'rgba(244, 193, 7, 1)',
      'rgba(3, 188, 114, 1)',
      'rgba(87, 42, 241, 1)',
      'rgba(255, 122, 0, 1)',

    ];

    const excludedKeys = ['totalonboardrecords','totalonboardingrecords'];

    const dynamicData = Object.entries(onboarding)
      .filter(([key]) => !excludedKeys.includes(key))
      .map(([key, value], index) => ({
        key,
        name: key
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' '),
        value,
        color: COLORS[index % COLORS.length]
      }));

    if (dynamicData.length === 0) {
      setData([{ name: 'No Data', value: 1, color: '#e0e0e0' }]);
    } else {
      setData(dynamicData);
    }
  }, [onboarding]);

  if (!onboarding) return <div>No data available</div>;

  const handleClick = (key) => {
    if (!key) return;
    const userIdParam = selectedUserId ? `&userId=${selectedUserId}` : '';
    navigate(`/clients?onboardingStep=${encodeURIComponent(key)}${userIdParam}`);
  };

  return (
    <Box
      sx={{
        background: 'rgba(255, 255, 255, 1)',
        padding: '24px',
        borderRadius: '20px',
        width: '100%',
        height: '100%',
        minHeight: '310px',
        boxShadow: '0 6px 24px rgba(41, 27, 59, 0.07)',
        border: '1px solid #ECE8FE',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        opacity: 1,
      }}
    >
      <Typography
        variant="h6"
        gutterBottom
        textAlign="center"
        fontWeight="bold"
        sx={{ marginTop: '5px', marginBottom: '12px' }}
      >
        Client Onboarding Status
      </Typography>

      <Box
          sx={{
            flex: 1,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap={2}
        >
        <Box sx = {{position: "relative", display: "flex", justifyContent: "center", alignItems: "center",  height: '160px', minWidth: '160px', flexShrink: 0, paddingTop: '10px'}} >
          <PieChart width={150} height={150}>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={70}
              fill="#8884d8"
              dataKey="value"
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>

          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
              paddingTop: '10px'
            }}
          >
            <Typography variant="h4" fontWeight="bold">
              {totalClients}
            </Typography>
            <Typography variant="body2">Clients</Typography>
          </Box>
        </Box>

        <List sx={{ marginLeft: { xs: 0, md: '0px' }, marginTop: { xs: '12px', md: 0 } }}>
          {data.length === 1 && data[0].name === 'No Data' ? (
            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="body2" color="text.secondary">
                    Onboarding metrics disabled
                  </Typography>
                }
              />
            </ListItem>
          ) : (
            data.map((item, index) => (
            <ListItem key={index} 
            sx={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingY: '4px', 
                  paddingX: 0,
                  cursor: 'pointer',
                  userSelect: 'none',
                  transition: 'background-color 0.3s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(87, 42, 241, 0.1)',         
                  }       
                }}
                onClick={() => handleClick(item.key)}
                  title={`Filter clients by ${item.name}`}
                >
              <Box
                sx={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  backgroundColor: item.color,
                  marginRight: '8px',
                }}
              />
              <ListItemText
                primary={
                  <Typography component="span">
                    <strong>{item.value}</strong> {item.name}
                  </Typography>
                }
              />
            </ListItem>
          ))
        )}
        </List>
      </Box>
      </Box>
    </Box>
  );
};

export default ClientOnboardingStatus;